import { CanDeactivateFn } from '@angular/router';
import { ProjectFormComponent } from '../projects/project-form/project-form.component';

export const canDeactivateProjectForm: CanDeactivateFn<ProjectFormComponent> = (component) => {
  if (!component.hasUnsavedChanges()) return true;
  return component.confirmDeactivate();
};
